import React from 'react'
import _ from 'lodash'

// If an onclick handler is provided, debounce it.
export const DebouncedButton = (props)=>(
  <button {...props} onClick={props.onClick && _.debounce(props.onClick, 800, { leading: true })}>
  </button>
)

